import { useState, useCallback } from 'react';

const useMapFilters = () => {
  const [filters, setFilters] = useState({
    // Location filters
    provinceId: null,
    districtId: null,
    searchText: '',
    
    // Business filters
    firmIds: [],
    activeProjectIds: [],
    passiveProjectIds: [],
    categoryIds: [],
    
    // Status filters 
    statusIds: [],
    notificationIds: [],
    
    // Banking filters
    includedBanks: [],
    excludedBanks: [],
    btmAtmOnsite: [],
    btmAtmOffsite: [],
    
    // Technical filters
    segment: null,
  });

  const getFilterSummary = useCallback(() => {
    const activeFilters = [];    
    if (filters.provinceId) activeFilters.push('İl');
    if (filters.districtId) activeFilters.push('İlçe');
    if (filters.searchText) activeFilters.push('Arama');
    if (filters.firmIds && filters.firmIds.length > 0) activeFilters.push(`${filters.firmIds.length} Firma`);
    if ((filters.activeProjectIds && filters.activeProjectIds.length > 0) || 
        (filters.passiveProjectIds && filters.passiveProjectIds.length > 0)) {
      const activeCount = filters.activeProjectIds ? filters.activeProjectIds.length : 0;
      const passiveCount = filters.passiveProjectIds ? filters.passiveProjectIds.length : 0;
      activeFilters.push(`${activeCount + passiveCount} Proje`);
    }
    if (filters.categoryIds && filters.categoryIds.length > 0) activeFilters.push(`${filters.categoryIds.length} Kategori`);
    if (filters.statusIds && filters.statusIds.length > 0) activeFilters.push(`${filters.statusIds.length} Durum`);
    if (filters.notificationIds && filters.notificationIds.length > 0) activeFilters.push(`${filters.notificationIds.length} Bildirim`);
    if (filters.includedBanks.length > 0) activeFilters.push(`${filters.includedBanks.length} Dahil Banka`);
    if (filters.excludedBanks.length > 0) activeFilters.push(`${filters.excludedBanks.length} Hariç Banka`);
    if (filters.btmAtmOffsite?.length > 0) activeFilters.push(`${filters.btmAtmOffsite.length} BKM Offsite`);
    if (filters.btmAtmOnsite?.length > 0) activeFilters.push(`${filters.btmAtmOnsite.length} BKM Onsite`);
    if (filters.segment?.length > 0) activeFilters.push('Segment');
    
    if (activeFilters.length === 0) {
      return 'Filtre yok';
    }
    
    return activeFilters.join(', ');
  }, [filters]);

  const updateFilter = useCallback((filterType, value, isStateUpdate = false) => {
    if (isStateUpdate) {
      setFilters(prevFilters => ({
        ...prevFilters,
        [filterType]: value
      }));
    } else {
      setFilters(prevFilters => ({
        ...prevFilters,
        [filterType]: value
      }));
    }
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({
      provinceId: null,
      districtId: null,
      searchText: '',
      
      // Business filters 
      firmIds: [],
      activeProjectIds: [],
      passiveProjectIds: [],
      categoryIds: [],
      
      // Status filters
      statusIds: [],
      notificationIds: [],
      
      // Banking filters
      includedBanks: [],
      excludedBanks: [],
      btmAtmOnsite: [],
      btmAtmOffsite: [],
      
      // Technical filters
      segment: null,
    });
  }, []);

  const getApiFilters = useCallback(() => {
    const apiFilters = {};
    if (filters.provinceId) apiFilters.il = filters.provinceId;
    if (filters.districtId) apiFilters.ilce = filters.districtId;
    if (filters.searchText) apiFilters.lokName = filters.searchText;
    
    const complexFilters = [];
    
    if (filters.firmIds?.length > 0) {
      filters.firmIds.forEach(firmId => {
        complexFilters.push(['firma', firmId]);
      });
    }
    
    if (filters.activeProjectIds?.length > 0) {
      filters.activeProjectIds.forEach(projectId => {
        complexFilters.push(['proje', projectId]);
      });
    }
    
    if (filters.passiveProjectIds?.length > 0) {
      filters.passiveProjectIds.forEach(projectId => {
        complexFilters.push(['proje', projectId]);
      });
    }
    
    if (filters.categoryIds?.length > 0) {
      filters.categoryIds.forEach(categoryId => {
        complexFilters.push(['kategori', categoryId]);
      });
    }
    
    if (filters.segment?.length > 0) {
      filters.segment.forEach(segmentId => {
        complexFilters.push(['segment', segmentId]);
      });
    }
    
    if (filters.notification !== null) {
      complexFilters.push(['bildirim', filters.notification]);
    }
    
    filters.includedBanks.forEach(bankId => {
      complexFilters.push(['mevcutbanka', bankId]);
    });
    
    filters.excludedBanks.forEach(bankId => {
      complexFilters.push(['namevcutbanka', bankId]);
    });
    
    if (filters.btmAtmOnsite.length > 0) {
      filters.btmAtmOnsite.forEach(bankId => {
        complexFilters.push(['btmAtmOnsite', bankId]);
      });
    }
    
    if (filters.btmAtmOffsite.length > 0) {
      filters.btmAtmOffsite.forEach(bankId => {
        complexFilters.push(['btmAtmOffsite', bankId]);
      });
    }
    
    if (complexFilters.length > 0) {
      apiFilters.filters = JSON.stringify(complexFilters);
    }
    
    return apiFilters;
  }, [filters]);

  return {
    filters,
    updateFilter,
    resetFilters,
    getFilterSummary,
    getApiFilters
  };
};

export default useMapFilters;
